import {
	FETCH_PRE_PACKAGE_PRICES_FAILURE,
	FETCH_PRE_PACKAGE_PRICES_SUCCESS,
} from "../../actionTypes";
import axios from "axios";
import { getStore } from "app/configureStore";
import env from "app/utils/env";

// Les action creators ci-dessous ne diffèrent que par les champs ajoutés à l'action de succès.
// track est fourni par SearchEngineContainer : le tag d'erreur part depuis le .catch, donc
// il ne peut pas être émis depuis le call site.
const fetchPrepackagePrices = (uri, track, successPayload) => {
	return dispatch => {
		const state = getStore().getState();
		const shop = state.shop;
		const endpoint = env("CONTENT_API_URL") || env("BASE_URL");

		const url = `${endpoint}/${state.productsVisibility}/${shop}/${uri}.json`;

		axios
			.get(url)
			.then(res => {
				dispatch({
					type: FETCH_PRE_PACKAGE_PRICES_SUCCESS,
					pricesPerDurations: res.data,
					...successPayload,
				});
			})
			.catch(err => {
				dispatch({
					type: FETCH_PRE_PACKAGE_PRICES_FAILURE,
				});
				track("error", {
					error: `Get ${url} : ${err.message} - ${err?.response?.statusText}`,
				});
			});
	};
};

export const fetchPrepackagePricesOfCity = (
	uri,
	departureCityCode,
	offerCode,
	contractType,
	track
) => fetchPrepackagePrices(uri, track, { departureCityCode, offerCode, contractType });

export const fetchPrepackagePricesOfAlternativeCity = (
	uri,
	departureCityCode,
	offerCode,
	contractType,
	track
) =>
	fetchPrepackagePrices(uri, track, {
		departureCityCode,
		offerCode,
		contractType,
		isAlternativeCity: true,
	});

export const fetchPrepackagePricesOfDurations = (uri, duration, offerCode, contractType, track) =>
	fetchPrepackagePrices(uri, track, { duration, offerCode, contractType });
